import * as React from 'react';
import clsx from 'clsx';
var themes = {
  "default": "Svg-default_2kN4X",
  "orange": "Svg-orange_19tb1",
  "red": "Svg-red_xi6MZ",
  "green": "Svg-green_su7pR",
  "purple": "Svg-purple_3fW-G",
  "blue": "Svg-blue_2Ak3M",
  "primary": "Svg-primary_rfFdk"
};
import { ProductBadge } from '../../../../Badges/ProductBadge';
import { getTheme } from '../../../../Badges/helpers';
import { ContentRow } from './components/ContentRow';
import { FooterRow } from './components/FooterRow';
import { IconRow } from './components/IconRow';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Item-root_G3IP0",
  "buttonContainer": "Item-buttonContainer_3juaa",
  "trashButton": "Item-trashButton_30EZb"
};
export default function Item({
  crossedPrice,
  title,
  price,
  details,
  payload,
  productType,
  process,
  handleRemoveAction
}) {
  return /*#__PURE__*/_jsxs("li", {
    className: clsx(styles.root, themes[getTheme(productType)]),
    children: [process && process !== 'create' && /*#__PURE__*/_jsx(ProductBadge, {
      productType: productType,
      process: process,
      payload: payload
    }), /*#__PURE__*/_jsx(IconRow, {
      productType: productType
    }), /*#__PURE__*/_jsx(ContentRow, {
      details: details,
      title: title
    }), /*#__PURE__*/_jsx(FooterRow, {
      price: price,
      crossedPrice: crossedPrice,
      handleRemoveAction: handleRemoveAction
    })]
  });
}